export default function Footer() {
  const year = new Date().getFullYear();
  const scrollTo = (id) => {
    const el = document.querySelector(id);
    if (el) el.scrollIntoView({ behavior: "smooth", block: "start" });
  };

  return (
    <footer
      data-testid="site-footer"
      className="bg-white border-t border-black/10 text-[#3A3A3A]"
    >
      <div className="max-w-7xl mx-auto px-6 md:px-10 py-16 md:py-20 grid grid-cols-1 md:grid-cols-12 gap-10">
        <div className="md:col-span-8">
          <div className="font-display text-[20px] text-[#0A0A0A] font-medium tracking-[-0.02em]">
            Binaifer Dulani
          </div>
          <a
            href="mailto:binaiferdulani@gmail.com"
            data-testid="footer-identity-email"
            className="mt-2 inline-block text-[14px] text-[#3A3A3A] hover:text-[#0A0A0A] transition-colors"
          >
            binaiferdulani@gmail.com
          </a>
        </div>

        <div className="md:col-span-4">
          <div className="text-[11px] uppercase tracking-[0.26em] text-[#6B6B6B] mb-5 font-medium">
            Explore
          </div>
          <ul className="space-y-3 text-[14px]">
            {[
              ["Work", "#work"],
              ["Coaching", "#coaching"],
              ["Speaking", "#speaking"],
              ["Press", "#press"],
              ["Services", "#services"],
              ["Book", "#booking"],
            ].map(([label, href]) => (
              <li key={href}>
                <a
                  href={href}
                  onClick={(e) => {
                    e.preventDefault();
                    scrollTo(href);
                  }}
                  data-testid={`footer-link-${label.toLowerCase().replace(/\s+/g, "-")}`}
                  className="text-[#3A3A3A] hover:text-[#0A0A0A] transition-colors"
                >
                  {label}
                </a>
              </li>
            ))}
          </ul>
        </div>
      </div>

      <div className="border-t border-black/10">
        <div className="max-w-7xl mx-auto px-6 md:px-10 py-6 flex flex-col sm:flex-row items-center justify-between gap-3 text-[11px] text-[#6B6B6B]">
          <div>© {year} Binaifer Dulani. All rights reserved.</div>
          <div className="uppercase tracking-[0.22em] font-medium">
            Crafted with intention
          </div>
        </div>
      </div>
    </footer>
  );
}
